import { useRef, useState } from 'react';
import LocationCheck from '../icons/LocationCheck';
import useOnClickOutside from '@/hooks/useOnClickOutside';
import ArrowIcon from '../icons/ArrowIcon';
import { useRouter } from 'next/router';

const MapLocations = ({ t, data, setBranches, setBranchInView, map }) => {
  const ref = useRef();
  const { locale } = useRouter();
  const [show, setShow] = useState(false);
  useOnClickOutside([ref], () => setShow(false));
  const [regs, setRegs] = useState(data);
  const [selectedReg, setSelectedReg] = useState({});

  const handleSearch = ({ target: { value } }) => {
    const result = {};
    for (const key in data) {
      if (data.hasOwnProperty(key) && key.includes(value)) {
        result[key] = data[key];
      }
    }
    const finalRes = value?.length > 0 ? result : data;
    setRegs(finalRes);
  };

  return (
    <>
      <div
        onClick={(e) => {
          e.stopPropagation();
          setShow((show) => !show);
        }}
        className='relative order-last flex w-full min-w-36 cursor-pointer items-center justify-between rounded-xl border bg-zinc-100 p-2.5 lg:order-none lg:w-fit'
      >
        <LocationCheck className='size-5' />
        <p className='mx-3 flex-1 text-[15px]'>
          {Object.entries(selectedReg)?.at(0)?.at(0) || t('Select City')}
        </p>
        <ArrowIcon className='mt-0.5 size-2.5 rotate-90' />

        <div
          ref={ref}
          className={`${
            !show ? 'hidden' : 'block'
          }  absolute left-0 top-full z-50 w-full min-w-52 rounded-md border bg-white p-2 shadow-lg *:text-[15px] *:text-black`}
        >
          <input
            type='text'
            placeholder={t('Search for your City')}
            className='w-full rounded-md border border-gray-200 bg-gray-50 px-2 py-1.5 focus-visible:outline-none'
            onChange={handleSearch}
            onClick={(e) => e.stopPropagation()}
          />
          <ul className='gray-scroll my-1 max-h-80 overflow-y-auto'>
            {Object.entries(regs)?.length ? (
              Object.entries(regs)?.map(([reg, branches], i) => (
                <li
                  key={i}
                  onClick={() => {
                    setSelectedReg({ [reg]: branches });
                  }}
                  className={`hover:text-secondary-700 mb-1 w-full border-b p-2  last:mb-0 last:border-none hover:text-primary`}
                >
                  {reg}
                </li>
              ))
            ) : (
              <div className=''>
                {locale === 'ar' ? 'لا توجد نتيجة' : 'Not result found'}
              </div>
            )}
          </ul>
        </div>
      </div>
      <button
        className='rounded-md bg-primary px-6 py-2 text-sm text-white max-sm:hidden'
        disabled={!Object.entries(selectedReg)?.length}
        onClick={() => {
          const [, /* reg */ branches] = Object.entries(selectedReg)?.at(0);
          setBranches(branches);
          setBranchInView(branches?.at(0));
          map.panTo({
            lng: parseFloat(branches?.at(0)?.lng),
            lat: parseFloat(branches?.at(0)?.lat),
          });
        }}
      >
        {t('Select City')}
      </button>
    </>
  );
};

export default MapLocations;
